import React, { useEffect, useState } from "react"
import { Link } from 'react-router-dom'

import axios from "axios"
import '../../../Styles/Modules/Proyectos/DashboardProyectos.scss'
import {Row, Col} from 'antd';
import Avatar from "../../Widgets/Avatar/Avatar";

export const formatMXN = (value) => {
    const n = Number(value ?? 0)
    const abs = Math.abs(n)
    const base = new Intl.NumberFormat("es-MX", {
        style: "currency",
        currency: "MXN",
        minimumFractionDigits: 2,
    }).format(abs)
    return n < 0 ? `-${base} MXN` : `${base} MXN`;
}

const CardTotal = ({desde, hasta}) => {

    const [loading, setLoading] = useState(true)
    const [totales, setTotales] = useState({
        totalIngresos: 0,
        totalEgresos: 0,
    })

    useEffect(()=>{

        const getSaldoTotal = async () => {
            try {
                setLoading(true)
                const params = (desde && hasta) ? { desde, hasta } : undefined
                const { data } = await axios.get("/dashboard-proyectos/saldo-total", {
                    params
                })
                setTotales(data)
            }catch(error) {
                console.error("Error al obtener los saldos totales", error)
            } finally {
                setLoading(false)
            }
        }

        getSaldoTotal()
    }, [desde, hasta])
    
    return (
        <div className="card">

            <Row gutter={[16, 5]}>
                <Col span={24}>
                    <label className="label-title">Total de Ingresos:</label>
                </Col>

                <Col span={24}>
                    <label className="label-value">
                        {formatMXN(totales.totalIngresos)}
                    </label>
                </Col>

                <Col span={24}>
                    <label className="label-title">Total de Egresos:</label>
                </Col>

                <Col span={24}>
                    <label className="label-value">
                        {formatMXN(totales.totalEgresos)}
                    </label>
                </Col>
            </Row>

        </div>
    )
}

const CardTopProyectosIngresos = ({desde, hasta}) => {
    const [loading, setLoading] = useState(true)
    const [proyectos, setProyectos] = useState([])

    useEffect(() => {

        const getTopProyectosIngreso = async () => {
            try {
                setLoading(true)
                const params = (desde && hasta) ? { desde, hasta } : undefined
                const { data } = await axios.get("/dashboard-proyectos/top-ingresos", { 
                    params 
                })
                setProyectos(Array.isArray(data) ? data : [])
            } catch (error) {
                console.error("Error al obtener los proyectos", error)
                setProyectos([])
            } finally {
                setLoading(false)
            }
        }
        getTopProyectosIngreso()

    }, [desde, hasta])

    const renderLogoUrl = (p) => {
        if (!p.logoName) return null
        const url = new URL(axios.defaults.baseURL + "/proyectos/logo/" + p.proyecto_id)
        url.searchParams.set("Authorization", sessionStorage.getItem("token"))
        url.searchParams.set("name", p.logoName)
        return url.href
    }

    return (
        <div className="card card-top-ingresos" aria-busy={loading}>
            <div className="card-header">
                <label className="label-title">Proyectos con más Ingresos:</label>
            </div>

            {!loading && (
                proyectos.length === 0 ? (
                <div className="card-empty">Aún no hay proyectos con Ingresos</div>
                ) : (
                    <div className="top-list">
                        {proyectos.map((p, i) => (
                            <Link
                                to={`/admin/proyectos/detalle/${p.proyecto_id}`}
                                className="top-item"
                                key={String(p.proyecto_id ?? i)}
                                style={{ 
                                    textDecoration: 'none', 
                                    color: 'inherit',
                                    display: 'flex',    
                                    alignItems: 'center',
                                    gap: 8,
                                    cursor: 'pointer'
                                }}
                            >
                                <Avatar
                                    size={28}
                                    color={p.color}
                                    {...(p.logoName ? { image: renderLogoUrl(p) } : { name: p.nombre })}
                                />
                                <span className="label-top">
                                    {i + 1}. {p.nombre} — {formatMXN(p.totalIngresos)}
                                </span>
                            </Link>
                        ))}
                    </div>

                )
            )}
        </div>
    )
}

const CardTopProyectosEgresos = ({ desde, hasta }) => {
    const [loading, setLoading] = useState(true)
    const [proyectos, setProyectos] = useState([])

    useEffect(() => {

        const getTopProyectosEgreso = async () => {
            try {
                setLoading(true)
                const params = (desde && hasta) ? { desde, hasta } : undefined
                const { data } = await axios.get("/dashboard-proyectos/top-egresos", { 
                    params 
                })
                setProyectos(Array.isArray(data) ? data : [])
            } catch (error) {
                console.error("Error al obtener los proyectos", error)
                setProyectos([])
            } finally {
                setLoading(false)
            }
        }
        getTopProyectosEgreso()

    }, [desde, hasta])

    const renderLogoUrl = (p) => {
        if (!p.logoName) return null
        const url = new URL(axios.defaults.baseURL + "/proyectos/logo/" + p.proyecto_id)
        url.searchParams.set("Authorization", sessionStorage.getItem("token"))
        url.searchParams.set("name", p.logoName)
        return url.href
    }

    return (
        <div className="card card-top-ingresos" aria-busy={loading}>
        <div className="card-header">
            <label className="label-title">Proyectos con más Egresos:</label>
        </div>

        {!loading && (
            proyectos.length === 0 ? (
            <div className="card-empty">Aún no hay proyectos con Egresos</div>
            ) : (
                <div className="top-list">
                    {proyectos.map((p, i) => (
                        <Link
                            to={`/admin/proyectos/detalle/${p.proyecto_id}`}
                            className="top-item"
                            key={String(p.proyecto_id ?? i)}
                            style={{ 
                                textDecoration: 'none', 
                                color: 'inherit',
                                display: 'flex',    
                                alignItems: 'center',
                                gap: 8,
                                cursor: 'pointer'
                            }}
                        >
                            <Avatar
                                size={28}
                                color={p.color}
                                {...(p.logoName ? { image: renderLogoUrl(p) } : { name: p.nombre })}
                                name={p.nombre}
                            />
                            <span className="label-top">
                                {i + 1}. {p.nombre} — {formatMXN(p.totalEgresos)}
                            </span>
                        </Link>
                    ))}
                </div>
            )
        )}
        </div>
    )
}

export  {
    CardTotal,
    CardTopProyectosIngresos,
    CardTopProyectosEgresos
}